    <header class="page-head">
      <div>
        <h1 class="page-title">About Central Profile</h1>
        <p class="page-subtitle">Central Profile is designed to reduce the friction of updating personal details across every institution and contact network that depends on them.</p>
      </div>
    </header>

    <section class="detail-grid">
      <article class="detail-card span-6">
        <h2 class="section-title">Why it exists</h2>
        <p class="label">Phone theft, SIM swaps, relocations, and account fraud all create urgent detail-change scenarios. Central Profile centralizes those updates into a secure user-controlled workflow.</p>
      </article>
      <article class="detail-card span-6">
        <h2 class="section-title">What it coordinates</h2>
        <ul class="simple-list">
          <li>Contact syncing and recovery</li>
          <li>Institution profile updates</li>
          <li>Payment and billing record maintenance</li>
          <li>Support escalation and service discovery</li>
        </ul>
      </article>
    </section>
